import { useStores } from '@/store';
import { observer } from 'mobx-react';
import React from 'react';
import { Form, FormField, FormGroup } from 'semantic-ui-react';
import style from './onboarding-submission-details.less';
import { FormTextInput } from '../Form';

export const OnboardingSubmissionDetailsBankingInfo = observer(() => {
  const { temporaryEmployeeStore } = useStores();

  const transitNumber = temporaryEmployeeStore.current?.transitNumber ?? '';
  const institutionNumber = temporaryEmployeeStore.current?.institutionNumber ?? '';
  const accountNumber = temporaryEmployeeStore.current?.accountNumber ?? '';

  return (
    <Form className={style.form_container}>
      <FormGroup inline className={style.form_group}>
        <FormField width={10}>
          <label htmlFor="transitNumber" className={style.form_label} style={{ minWidth: 150 }}>
            TRANSIT NUMBER
          </label>
          <FormTextInput id="transitNumber" name="Transit Number" value={transitNumber} copyable />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={10}>
          <label htmlFor="institutionNumber" className={style.form_label} style={{ minWidth: 150 }}>
            INSTITUTION NUMBER
          </label>
          <FormTextInput
            id="institutionNumber"
            name="Institution Number"
            value={institutionNumber}
            copyable
          />
        </FormField>
      </FormGroup>

      <FormGroup inline className={style.form_group}>
        <FormField width={10}>
          <label htmlFor="accountNumber" className={style.form_label} style={{ minWidth: 150 }}>
            ACCOUNT NUMBER
          </label>
          <FormTextInput id="accountNumber" name="Account Number" value={accountNumber} copyable />
        </FormField>
      </FormGroup>
    </Form>
  );
});
